import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin({
    name: 'external_accessibility',
    parallel: true,
    setup() {
        if (!import.meta.client) return {};

        const MODAL_ARIA_LABEL = 'Wallet connect modal';
        const XSOLLA_BUTTON_PREFIX = 'Xsolla Metaframe';
        const XSOLLA_METAFRAME_ID = '__xsolla_metaframe_container';

        let dialogAccessibilityApplied = false;
        let buttonsAccessibilityApplied = false;

        const enhanceModalAccessibility = () => {
            if (dialogAccessibilityApplied) return false;

            const wcmModalElements = document.querySelectorAll('wcm-modal');
            let modalFixed = false;

            wcmModalElements.forEach((wcmModal) => {
                if (!wcmModal.shadowRoot) return;

                const innerDialog = wcmModal.shadowRoot.querySelector('[role="alertdialog"]');
                if (!innerDialog || innerDialog.hasAttribute('aria-labelledby')
                    || innerDialog.hasAttribute('aria-label')) return;

                innerDialog.setAttribute('aria-label', MODAL_ARIA_LABEL);
                modalFixed = true;
            });

            return modalFixed;
        };

        const enhanceButtonsAccessibility = () => {
            if (buttonsAccessibilityApplied) return false;

            const xsollaMetaframe = document.getElementById(XSOLLA_METAFRAME_ID);
            if (!xsollaMetaframe || !xsollaMetaframe.shadowRoot) return false;

            const buttons = xsollaMetaframe.shadowRoot.querySelectorAll('button');
            if (buttons.length === 0) return false;

            let buttonsFixed = false;
            buttons.forEach((button, index) => {
                if (button.hasAttribute('aria-label')) return;

                const buttonText = button.textContent?.trim();
                const label = buttonText || `${XSOLLA_BUTTON_PREFIX} ${index + 1}`;
                button.setAttribute('aria-label', label);
                buttonsFixed = true;
            });

            return buttonsFixed || buttons.length > 0;
        };

        const enhanceAccessibility = () => {
            if (dialogAccessibilityApplied && buttonsAccessibilityApplied) {
                observer.disconnect();
                return;
            }

            if (enhanceModalAccessibility()) {
                dialogAccessibilityApplied = true;
            }
            if (enhanceButtonsAccessibility()) {
                buttonsAccessibilityApplied = true;
            }
        };

        const observer = new MutationObserver(enhanceAccessibility);
        observer.observe(document.body, { childList: true, subtree: true });

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', enhanceAccessibility);
        }
        else {
            enhanceAccessibility();
        }

        return {};
    }
});
